import React from 'react';
import { Link,  } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';


const AdminFooter: React.FC = () => {
  const { t } = useLanguage();
  return (
    <div id="kt_app_footer" className="app-footer bg-base text-white" style={{ marginTop: 'auto' }}>
      <div className="app-container container-fluid d-flex flex-column flex-md-row flex-center flex-md-stack py-3">
        <div className="text-dark order-2 order-md-1">
          <span className="text-white fw-semibold me-1">{new Date().getFullYear()} &copy;</span>
          <a href="#" className="text-white">Fesilah</a>
        </div>
        <ul className="menu menu-gray-600 menu-hover-primary fw-semibold order-1">
          <li className="menu-item">
            <Link to="/#about" target='_blank' className="menu-link text-white px-2">{t('About')}</Link>
          </li>
          <li className="menu-item">
            <Link to="/#contact" target='_blank' className="menu-link text-white px-2">{t('Support')}</Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default AdminFooter;

